import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

function EditNameModal({ show, initialValue, onHide, onAccept, onCancel }) {
  const [value, setValue] = useState('');

  const footer = (
    <>
      <Button
        label='Cancel'
        icon='pi pi-times'
        onClick={onCancel}
        className='p-button-outlined mr-2'
      />
      <Button
        label='Accept'
        icon='pi pi-check'
        onClick={() => onAccept(value)}
        className='p-button-primary'
      />
    </>
  );

  return (
    <Dialog
      visible={show}
      onHide={onHide}
      modal
      style={{ width: '500px' }}
      position='center'
      header='Edit Name'
      footer={footer}
      draggable={false}
      resizable={false}
      closeOnEscape
    >
      <div className='d-flex justify-content-center'>
        <div className='col w-full my-2 pb-2 container-name'>
          <InputText
            className='new-test-name w-full'
            placeholder='Insert new name'
            onChange={(e) => setValue(e.target.value)}
            defaultValue={initialValue}
          />
        </div>
      </div>
    </Dialog>
  );
}
export default EditNameModal;
